import React, { FC } from "react";
import { NavLink, useLocation } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhotoFilm,
} from "@fortawesome/free-solid-svg-icons";

function isCurrentPath(link: string, pathname: string) {
    return (link === "/" && pathname === "/") ||
        (link !== "/" && pathname && pathname.startsWith(link));
}

const renderSidebarNavLink = (link: string, label: string, pathname: string) => (
    <NavLink to={link}>
        <div className="relative h-6 mb-3 flex hover:cursor-pointer">
            <li className="my-[3px] flex cursor-pointer items-center pl-2 pr-3">
                <span
                    className={
                        isCurrentPath(link, pathname)
                            ? "font-bold text-brand-500 dark:text-white"
                            : "font-medium text-gray-600"
                    }
                >
                </span>
                <p
                    className={
                        isCurrentPath(link, pathname)
                            ? "flex font-bold text-brand-700 dark:text-white"
                            : "flex font-medium text-gray-600"
                    }
                >
                    {label}
                </p>
            </li>
            {isCurrentPath(link, pathname) && <div className="absolute top-px h-6 w-1 rounded-lg bg-brand-500 end-0 dark:bg-brand-400"></div>}
        </div>
    </NavLink>
);

const renderHeaderNavLink = (link: string, label: string, pathname: string) => (
    <NavLink to={link}>
        <div className="relative h-6 mb-3 flex hover:cursor-pointer">
            <li
                className={`my-[3px] flex cursor-pointer items-center pl-2 pr-3`}
            >
                <span
                    className={
                        isCurrentPath(link, pathname)
                            ? "font-bold text-brand-500 dark:text-white"
                            : "font-medium text-gray-600"
                    }
                >
                </span>
                <p
                    className={
                        isCurrentPath(link, pathname)
                            ? "flex font-bold text-brand-700 dark:text-white"
                            : "flex font-medium text-gray-600"
                    }
                >
                    {label}
                </p>
            </li>
            {isCurrentPath(link, pathname) && <div className="absolute bottom-0 w-6 h-1 rounded-lg bg-brand-500 end-4 dark:bg-brand-400"></div>}
        </div>
    </NavLink>
);

interface SidebarProps {
    pathname: string;
    children: React.ReactNode;
}

const Sidebar: FC<SidebarProps> = ({
    pathname,
    children,
}) => {
    return (
        <>
            <div
                className="!z-5 flex flex-col min-h-full max-w-[160px] rounded-2xl bg-white bg-clip-border backdrop-blur-xl shadow-xl shadow-shadow-500 pb-10 dark:!bg-brand-700 dark:text-white"
            >
                <div className="mx-2 mb-0 mt-3 p-2 h-max">
                    <div className="flex flex-row items-center justify-between">
                        <div className="flex flex-col items-center justify-between">
                            <NavLink to="/dashboard" className="flex flex-row items-center justify-between">
                                <div className="mr-1">
                                    <FontAwesomeIcon icon={faPhotoFilm} className={"text-2xl"} fixedWidth />
                                </div>
                                <div>
                                    <p className="font-semibold uppercase text-sm">METADATA INSIGHTS</p>
                                </div>
                            </NavLink>
                            <div className="flex flex-row mt-3">
                                {renderHeaderNavLink("/dashboard/epg/grid", "EPG", pathname)}
                                {renderHeaderNavLink("/dashboard/vod/assets/standalone-content", "VOD", pathname)}
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                {children}
                </div>
            </div>
        </>
    );
};

export const AdminSidebar: FC = () => {
    const { pathname } = useLocation();

    return (
        <Sidebar pathname={pathname}>
            <ul className="mb-auto pt-1">
                {renderSidebarNavLink("/dashboard", "Home", pathname)}
            </ul>
        </Sidebar>
    );
};


export const EPGAdminSidebar: FC = () => {
    const { pathname } = useLocation();

    return (
        <Sidebar pathname={pathname}>
            <ul className="mb-auto pt-1">
                {/*{renderSidebarNavLink("/dashboard/epg/home", "Home", pathname)}*/}
                {renderSidebarNavLink("/dashboard/epg/grid", "EPG Grid", pathname)}
                {/*{renderSidebarNavLink("/dashboard/epg/ingest", "Ingest", pathname)}*/}
            </ul>
        </Sidebar>
    );
};


export const VODAdminSidebar: FC = () => {
    const { pathname } = useLocation();

    return (
        <Sidebar pathname={pathname}>
            <ul className="mb-auto pt-1">
                {/*{renderSidebarNavLink("/dashboard/vod/home", "Home", pathname)}*/}
                {renderSidebarNavLink("/dashboard/vod/assets/standalone-content", "Assets", pathname)}
                {renderSidebarNavLink("/dashboard/vod/fpb-summary", "FPB Summary", pathname)}
            </ul>
        </Sidebar>
    );
};
